import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'
import AppSocialsLinks from '../app-socials-links'

export default
{
    name: 'app-header',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon,
        AppSocialsLinks
    },

    data() {
        return {
            isHidden: false,
            colorLogotype: 'white',
            colorMenu: 'white',
            small: false,
            borderVisible: false,
            pageSize: 0
        }
    },

    created() {
        this.activeIndex = null
        this.hiddenTimeout = null

        this.eventHub.$on('page-home:onActiveIndexChange', this.onActiveIndexChange)
        this.eventHub.$on('application:route-change', this.onRouteChange)
    },

    mounted() {
        this.eventHub.$emit('app-header:mounted')

        this.$items = this.$el.querySelectorAll('.c-header__nav__list__item')
    },

    destroyed() {
        this.eventHub.$off('page-home:onActiveIndexChange', this.onActiveIndexChange)
        this.eventHub.$off('application:route-change', this.onRouteChange)
    },

    methods: {
        _onClickOnLogotype() {
            if (this.$root.componentId === this.$root.CONFIG.pages.home.name) {
                if (this.activeIndex !== 0) {
                    this.eventHub.$emit('page-home:changeActiveIndexTo', 0)
                }
            } else {
                this.$root.router.push(this.$root.CONFIG.pages.home.path)
            }
            // if (this.$root.componentId !== this.$root.CONFIG.pages.home.name) {
            //     this.$root.router.push(this.$root.CONFIG.pages.home.path)
            // }
        },

        _getURLFromComponent(component) {
            let url = '/'

            Object.keys(this.CONFIG.pages).forEach(key => {
                const page = this.CONFIG.pages[key]
                if (page.name === component) {
                    url = page.path
                }
            })

            return url
        },

        onRouteChange(to) {
            this.eventHub.$emit('app-header:mounted')

            this.colorMenu = 'white'
            this.colorLogotype = 'white'

            this.small = to.name !== this.CONFIG.pages.home.name
        },

        onActiveIndexChange(index) {
            this.activeIndex = index
            
            this.isHidden = true
            
            if (this.hiddenTimeout) {
                window.clearTimeout(this.hiddenTimeout)
                this.hiddenTimeout = null
            }
            
            this.hiddenTimeout = window.setTimeout(() => {
                this.hiddenTimeout = null
                
                if (index !== 0 && index !== 2) {
                    this.small = true
                } else {
                    this.small = false
                }
                
                if (index === 0 || index === 2) {
                    this.borderVisible = false
                } else {
                    this.borderVisible = true
                }

                switch (index) {
                case 0:
                    this.colorLogotype = 'white'
                    this.colorMenu = 'white'
                    break
                case 1:
                    this.colorLogotype = 'black'
                    this.colorMenu = 'black'
                    break
                case 2:
                    this.colorLogotype = 'white'
                    this.colorMenu = 'white'
                    break
                case 3:
                    this.colorLogotype = 'white'
                    this.colorMenu = 'white'
                    break
                case 4:
                    this.colorLogotype = 'black'
                    this.colorMenu = 'white'
                    break
                case 5:
                    this.colorLogotype = 'white'
                    this.colorMenu = 'white'
                    break
                default:
                    break
                }
                
                this.isHidden = false
            }, 1400)
        },

        _openMenu() {
            this.$root.isMenuOpened = true

            // document.body.classList.add('u-overlow-h')
        },

        _closeMenu() {
            this.$root.isMenuOpened = false

            // document.body.classList.remove('u-overlow-h')
        },

        // HTML ACTIONS
        _onMouseenterItem(index) {
            // Remove 'is-hovered' class on each item
            this.$items.forEach(item => {
                item.classList.remove('is-hovered')
            })

            // Add 'is-hovered' class on hovered item
            this.$items.forEach(item => {
                if (parseInt(item.getAttribute('index'), 10) === index) {
                    item.classList.add('is-hovered')
                }
            })
        },

        _onMouseleaveItem() {
            // Remove 'is-hovered' class on each item
            this.$items.forEach(item => {
                item.classList.remove('is-hovered')
            })

            // Add 'is-hovered' class on active item
            this.$root.content.global.header.links.forEach((item, index) => {
                if (this.$root.componentId === item.component) {
                    this.$items.forEach(it => {
                        if (parseInt(it.getAttribute('index'), 10) === index) {
                            it.classList.add('is-hovered')
                        }
                    })
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-header/script.js